import Modal from 'components/Modal/Modal'
import TooltipBadge from 'components/TooltipBadge/TooltipBadge'
import FenetresAide from 'enums/FenetresAide'
import { markFenetreAideAsSeen } from 'redux/features/utilisateur/slice'
import { useAppDispatch } from 'redux/hooks'
import { fetchWithCheckAuthorization } from 'utils/fetchWithAuthorization'
import { Button } from 'react-bootstrap'
import Translation from 'assets/default/translation.json'
import Urls from 'assets/default/url.json'
import s from './PremierAccesCiblerBienAVendre.module.scss'

interface Props {
  show: boolean
  onHide: () => void
}

const PremierAccesCiblerBienAVendre = ({
  show,
  onHide,
}: Props): JSX.Element => {
  const dispatch = useAppDispatch()
  const onClose = () => {
    fetchWithCheckAuthorization(
      `/api/help/${FenetresAide.PremierAccesCiblerBienAVendre}/mark-as-seen`,
      {
        method: 'POST',
      }
    )
    dispatch(markFenetreAideAsSeen(FenetresAide.PremierAccesCiblerBienAVendre))
    onHide()
  }

  return (
    <Modal
      additionalModalClassNames={s.modal}
      show={show}
      title="Félicitations, tu as accès à l'espace «&nbsp;Cibler biens à vendre&nbsp;» !"
      body={
        <div>
          Bienvenue !<br />
          <br />
          <b>
            Pour utiliser pleinement l&apos;outil, il est absolument nécessaire
            de vous former à son utilisation :
          </b>
          <ol>
            {typeof Urls.pagesOmega.formation === 'string' && (
              <li>
                Inscrivez-vous à la prochaine formation en ligne{' '}
                <b>« {Translation.common.formationBienAVendre} »</b> dans{' '}
                <Button
                  className={s.link}
                  variant="link"
                  target="_blank"
                  href={Urls.pagesOmega.formation}
                >
                  l&apos;Académie
                </Button>{' '}
                (rubrique Formation en ligne de perfectionnement)
              </li>
            )}
            {(typeof Urls.videos.decouvreOutil === 'string' ||
              typeof Urls.videos.geolocaliseUnBien === 'string') && (
              <li>
                Regarde vite les tutoriels eLearning (
                {typeof Urls.videos.decouvreOutil === 'string' && (
                  <>
                    <Button
                      className={s.link}
                      variant="link"
                      target="_blank"
                      href={Urls.videos.decouvreOutil}
                    >
                      Je découvre l&apos;outil {Translation.common.produit}
                    </Button>
                    ,{' '}
                  </>
                )}
                {typeof Urls.videos.geolocaliseUnBien === 'string' && (
                  <Button
                    className={s.link}
                    variant="link"
                    target="_blank"
                    href={Urls.videos.geolocaliseUnBien}
                  >
                    Je géolocalise un bien grâce à {Translation.common.produit}
                  </Button>
                )}
                )
              </li>
            )}
            <li>
              Aide-toi des nombreux espaces d&apos;information (marqués par un{' '}
              <TooltipBadge label="exemple" tooltip={<span>🥳</span>} />)
            </li>
          </ol>
          Bonnes recherches !
          <div className={s.btns}>
            <Button className={s.btnA} href="/">
              Je reviendrai une fois formé(e)
            </Button>
            <Button className={s.btnB} onClick={onClose}>
              Je suis déjà formé(e)
            </Button>
          </div>
        </div>
      }
      onCloseButtonClick={onClose}
    />
  )
}

export default PremierAccesCiblerBienAVendre
